// extracted by mini-css-extract-plugin
export default {"component":"dldyw5","mobileLayout":"dFd9qK"};